import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import Outlets_1 from "../images/8.jpeg";
import Outlets_2 from "../images/blank.jpg";

const Outlets = () => {
  const outlets = [
    {
      name: 'Chennai Saidapet',
      type: 'Primary Hub',
      address: '73/3, Ground Floor, West Saidapet, Chennai - 600 015',
      phone: '+91-7397382501',
      email: 'koorum@womenshgenterprises.com',
      timings: '6:00 AM - 8:00 PM',
      services: ['Milk', 'Paneer', 'Ghee', 'Butter', 'Curd','Yogurt'],
      capacity: '200+ Liters/Day',
      image: Outlets_1,
      shgMembers: 25,
      established: '2021'
    },
    {
      name: 'Thimmasamuthiram  Processing Unit',
      type: 'Processing Center',
      address: 'XXXXXXXXX',
      phone: '+91-XXXXXXXXX',
      email: 'vathiyur@womenshgenterprises.com',
      timings: '5:30 AM - 9:00 PM',
      services: ['10+ @ Kanchipuram District'],
      capacity: '150+ Liters/Day',
      image: Outlets_2,
      shgMembers: 18,
      established: '2022'
    },
    // {
    //   name: 'Thimmasamuthiram Collection Point',
    //   type: 'Collection Center',
    //   address: 'Thimmasamuthiram Village, Kanchipuram District, Tamil Nadu',
    //   phone: '+91-XXXXXXXXX',
    //   email: 'thimmasamuthiram@womenshgenterprises.com',
    //   timings: '6:00 AM - 7:00 PM',
    //   services: ['Milk Collection', 'IoT Testing', 'Farmer Support', 'Fresh Milk Sales'],
    //   capacity: '100+ Liters/Day',
    //   image: 'https://images.pexels.com/photos/1051123/pexels-photo-1051123.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=2',
    //   shgMembers: 12,
    //   established: '2022'
    // },
    // {
    //   name: 'Aariyaperumbakkam Center',
    //   type: 'Collection Center',
    //   address: 'Aariyaperumbakkam Village, Kanchipuram District, Tamil Nadu',
    //   phone: '+91-XXXXXXXXX',
    //   email: 'aariyaperumbakkam@womenshgenterprises.com',
    //   timings: '6:30 AM - 7:30 PM',
    //   services: ['Milk Collection', 'Quality Analysis', 'Training Programs', 'Technical Support'],
    //   capacity: '80+ Liters/Day',
    //   image: 'https://images.pexels.com/photos/1089302/pexels-photo-1089302.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=2',
    //   shgMembers: 8,
    //   established: '2023'
    // },
    // {
    //   name: 'Sembarumbakkam Outlet',
    //   type: 'Retail Outlet',
    //   address: 'Sembarumbakkam Village, Kanchipuram District, Tamil Nadu',
    //   phone: '+91-XXXXXXXXX',
    //   email: 'sembarumbakkam@womenshgenterprises.com',
    //   timings: '7:00 AM - 8:00 PM',
    //   services: ['Retail Sales', 'Product Distribution', 'Customer Support', 'Bulk Orders'],
    //   capacity: '300+ Products/Day',
    //   image: 'https://images.pexels.com/photos/264537/pexels-photo-264537.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=2',
    //   shgMembers: 6,
    //   established: '2023'
    // }
  ];

  const getTypeColor = (type) => {
    switch (type) {
      case 'Primary Hub': return 'primary';
      case 'Processing Center': return 'success';
      case 'Collection Center': return 'info';
      case 'Retail Outlet': return 'warning';
      default: return 'secondary';
    }
  };

  const upcomingOutlets = [
    {
      name: 'Tiruvallur Processing Unit',
      expectedOpening: 'Q2 2024',
      status: 'Under Construction',
      plannedServices: ['Large Scale Processing', 'Cold Storage', 'Distribution Hub']
    },
    {
      name: 'Chengalpattu Collection Center',
      expectedOpening: 'Q3 2024',
      status: 'Site Selection',
      plannedServices: ['Milk Collection', 'IoT Testing', 'Training Center']
    },
    {
      name: 'Chennai Retail Store',
      expectedOpening: 'Q4 2024',
      status: 'Planning Phase',
      plannedServices: ['Premium Retail', 'Online Orders', 'Home Delivery Hub']
    }
  ];

  const totalStats = {
    totalOutlets: outlets.length,
    totalCapacity: '830+',
    totalSHGMembers: outlets.reduce((sum, outlet) => sum + outlet.shgMembers, 0),
    avgOperatingHours: '13'
  };

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section className="py-5 text-white hero_sec" style={{ background: 'linear-gradient(135deg, #2E8B57, #4682B4)' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Our Outlets</h1>
              <p className="fs-5">Find WiSE collection centers, processing units, and retail outlets near you</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Network Statistics */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-4">
              <h2 className="fw-bold mb-3">Our Network</h2>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="text-center mb-4">
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="display-6 fw-bold text-primary">{totalStats.totalOutlets}</div>
                <p className="small text-muted mb-0">Active Outlets</p>
              </div>
            </Col>
            <Col md={3} className="text-center mb-4">
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="display-6 fw-bold text-success">{totalStats.totalCapacity}</div>
                <p className="small text-muted mb-0">Liters/Day Capacity</p>
              </div>
            </Col>
            <Col md={3} className="text-center mb-4">
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="display-6 fw-bold text-info">{totalStats.totalSHGMembers}</div>
                <p className="small text-muted mb-0">SHG Members</p>
              </div>
            </Col>
            <Col md={3} className="text-center mb-4">
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="display-6 fw-bold text-warning">{totalStats.avgOperatingHours}</div>
                <p className="small text-muted mb-0">Avg. Hours/Day</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Current Outlets */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Current Outlets</h2>
              <p className="fs-5 text-muted">Our operational centers serving rural communities</p>
            </Col>
          </Row>
          <Row>
            {outlets.map((outlet, index) => (
              <Col lg={6} key={index} className="mb-4">
                <Card className="border-0 shadow card-hover h-100">
                  <Row className="g-0">
                    <Col md={4}>
                      <img 
                        src={outlet.image} 
                        alt={outlet.name}
                        className="img-fluid h-100 w-100"
                        style={{ objectFit: 'cover', borderRadius: '8px 0 0 8px' }}
                      />
                    </Col>
                    <Col md={8}>
                      <Card.Body className="p-4">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <Card.Title className="fw-bold h5">{outlet.name}</Card.Title>
                          <Badge bg={getTypeColor(outlet.type)}>{outlet.type}</Badge>
                        </div>
                        
                        <div className="mb-2">
                          <small className="text-muted">📍 {outlet.address}</small>
                        </div>
                        
                        <div className="row mb-3">
                          <div className="col-6">
                            <small className="text-muted">📞 {outlet.phone}</small>
                          </div>
                          <div className="col-6">
                            <small className="text-muted">🕒 {outlet.timings}</small>
                          </div>
                        </div>

                        <div className="mb-3">
                          <h6 className="fw-bold small">Available:</h6>
                          <div className="d-flex flex-wrap gap-1">
                            {outlet.services.slice(0, 3).map((service, idx) => (
                              <Badge key={idx} bg="light" text="dark" className="small">
                                {service}
                              </Badge>
                            ))}
                            {outlet.services.length > 3 && (
                              <Badge bg="light" text="dark" className="small">
                                +{outlet.services.length - 3} more
                              </Badge>
                            )}
                          </div>
                        </div>

                        {/* <div className="row small text-muted">
                          <div className="col-6">
                            <strong>Capacity:</strong> {outlet.capacity}
                          </div>
                          <div className="col-6">
                            <strong>SHG Members:</strong> {outlet.shgMembers}
                          </div>
                        </div> */}
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Services at Outlets */}
      <section className="section-padding" style={{ backgroundColor: '#f8f9fa' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Services at Our Outlets</h2>
              <p className="fs-5 text-muted">What you can expect at each type of outlet</p>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="mb-4">
              <Card className="border-0 shadow-sm hover-lift h-100 text-center">
                <Card.Body className="p-4">
                  <div style={{ fontSize: '3rem' }}>🏭</div>
                  <h5 className="fw-bold">Processing Centers</h5>
                  <ul className="list-unstyled small text-muted">
                    <li>✓ Value-added products</li>
                    <li>✓ Quality control</li>
                    <li>✓ Packaging & distribution</li>
                    <li>✓ Cold storage facilities</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="border-0 shadow-sm hover-lift h-100 text-center">
                <Card.Body className="p-4">
                  <div style={{ fontSize: '3rem' }}>📊</div>
                  <h5 className="fw-bold">Collection Centers</h5>
                  <ul className="list-unstyled small text-muted">
                    <li>✓ IoT milk testing</li>
                    <li>✓ Fair price calculation</li>
                    <li>✓ Farmer support</li>
                    <li>✓ Training programs</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="border-0 shadow-sm hover-lift h-100 text-center">
                <Card.Body className="p-4">
                  <div style={{ fontSize: '3rem' }}>🛒</div>
                  <h5 className="fw-bold">Retail Outlets</h5>
                  <ul className="list-unstyled small text-muted">
                    <li>✓ Fresh dairy products</li>
                    <li>✓ Bulk orders</li>
                    <li>✓ Customer support</li>
                    <li>✓ Home delivery</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="border-0 shadow-sm hover-lift h-100 text-center">
                <Card.Body className="p-4">
                  <div style={{ fontSize: '3rem' }}>🎯</div>
                  <h5 className="fw-bold">Primary Hubs</h5>
                  <ul className="list-unstyled small text-muted">
                    <li>✓ All services combined</li>
                    <li>✓ Training headquarters</li>
                    <li>✓ Technology center</li>
                    <li>✓ Administrative support</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Upcoming Outlets */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Coming Soon</h2>
              <p className="fs-5 text-muted">Expanding our network to serve more communities</p>
            </Col>
          </Row>
          <Row>
            {upcomingOutlets.map((outlet, index) => (
              <Col lg={4} key={index} className="mb-4">
                <Card className="border-0 shadow-sm hover-lift h-100">
                  <Card.Body className="p-4 text-center">
                    <div style={{ fontSize: '2.5rem' }}>🏗️</div>
                    <Card.Title className="fw-bold h5 mt-3">{outlet.name}</Card.Title>
                    <div className="mb-3">
                      <Badge bg="warning">{outlet.status}</Badge>
                      {/* <div className="mt-2">
                        <small className="text-muted">Expected: {outlet.expectedOpening}</small>
                      </div> */}
                    </div>
                    <h6 className="fw-bold small">Planned Services:</h6>
                    <ul className="list-unstyled small text-muted">
                      {outlet.plannedServices.map((service, idx) => (
                        <li key={idx}>✓ {service}</li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Find Nearest Outlet */}
      <section className="py-5 text-white" style={{ background: 'linear-gradient(135deg, #2E8B57, #4682B4)' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Find Your Nearest Outlet</h2>
              <p className="fs-5 mb-4">
                Need help finding the closest WiSE outlet? Contact us for directions and availability information.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button className="btn btn-light btn-lg px-4">
                  Get Directions
                </button>
                <button className="btn btn-outline-light btn-lg px-4">
                  Call for Info
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Outlets;